export const SharedKey = {
  pageSize: 'pageSize',
  currentPage: 'currentPage',
  fields: 'fields',
  sort: 'sort',
  states: 'states',
  status: 'status',
  statuses: 'statuses',
  searchText: 'searchText',
  shipmentId: 'shipmentId',
  shipmentEntryId: 'shipmentEntryId',
  sku: 'sku',
  creditClaimCode: 'creditClaimCode'
}

export const SharedValue = {
  workInProgress: 'Work in Progress.',
  pageSize: 5,
  full: 'FULL',
  errorTryAgain: 'Error occurred. Please refresh the page.',
  documentNotFound: 'Required document not found',
  errorEndCustomerNotFound: 'End customer not found. Please try again or click on new customer button',
  errorBusinessNotFound:
    'End customer account number not found. Please try again with valid account number or click on new customer button',
  serviceProductsNotFound: 'No products found for the selected service.',
  errorProuctNotFound: 'No products found. Please try again.',
  incorrectorderNumber: 'Order number is incorrect. please try again',
  creditClaimSubmitted: 'The credit claim has been successfully submitted.',
  selectQuantity: 'Please add the quantity you are claiming for all products.',
  noOrdersAvailable: 'No order is available.',
  invalidDocument: 'Invalid Document',
  photoMandatory: 'Please add a photo to support your claim',
  commentMandatory: 'Please add your Comments'
}

export const SharedErrorType = {
  notFound404: 'notFound404'
}
